<template>
  <section>
    <el-form
      ref="paylinksForm"
      :model="paylinksForm"
      :rules="paylinksFormRules" 
      label-width="150px"
    >
      <el-form-item
        label="Type"
        prop="type"
      >
        <gx-select
          v-model="type"
          :show-label="false"
          :options="typeOptions"
          track-by="value"
          label="name"
        >
          <template #selectedLabel="{ option }">{{ option.name }}</template>
          <template #option="{ option }">{{ option.name }}</template>
        </gx-select>
      </el-form-item>

      <div v-if="type">
        <el-form-item prop="utmSource">
          <span slot="label">
            UTM Source
          </span>
          <el-input v-model.trim="paylinksForm.utmSource"/>
        </el-form-item>
        <el-form-item prop="utmMedium">
          <span slot="label">
            UTM Medium
          </span>
          <el-input v-model.trim="paylinksForm.utmMedium"/>
        </el-form-item>
        <el-form-item prop="utmCampaign">
          <span slot="label">
            UTM Campaign
          </span>
          <el-input v-model.trim="paylinksForm.utmCampaign"/>
        </el-form-item>
        <el-form-item prop="utmSalescode">
          <span slot="label">
            UTM Salescode
          </span>
          <el-input v-model.trim="paylinksForm.utmSalescode"/>
        </el-form-item>
        <el-form-item prop="pageTitle">
          <span slot="label">
            Page Title
          </span>
          <el-input v-model.trim="paylinksForm.pageTitle"/>
        </el-form-item>
        <el-form-item prop="bannerImage">
          <span slot="label">
            Banner Image
          </span>
          <el-input v-model.trim="paylinksForm.bannerImage"/>
        </el-form-item>
        <el-form-item prop="shopNowLink">
          <span slot="label">
            Shop Now Link
          </span>
          <el-input v-model.trim="paylinksForm.shopNowLink"/>
        </el-form-item>
        <el-form-item prop="productLink1">
          <span slot="label">
            Product Link #1
          </span>
          <el-input v-model.trim="paylinksForm.productLink1"/>
        </el-form-item>
        <el-form-item prop="productLink2">
          <span slot="label">
            Product Link #2
          </span>
          <el-input v-model.trim="paylinksForm.productLink2"/>
        </el-form-item>
        <el-form-item prop="productLink3">
          <span slot="label">
            Product Link #3
          </span>
          <el-input v-model.trim="paylinksForm.productLink3"/>
        </el-form-item>
        <el-form-item prop="productLink4">
          <span slot="label">
            Product Link #4
          </span>
          <el-input v-model.trim="paylinksForm.productLink4"/>
        </el-form-item>
        <el-form-item prop="productLink5">
          <span slot="label">
            Product Link #5
          </span>
          <el-input v-model.trim="paylinksForm.productLink5"/>
        </el-form-item>
        <div class="button-group">
          <el-button @click="handleClear">{{ $t('button.clear') }}</el-button>
          <el-button
            type="primary"
            @click="handleGenerate">{{ $t('button.generate') }}</el-button>
        </div>

        <div
          v-if="generatedLongLinks"
          class="links-result-container"
        >
          <h3>
            Generated Paylinks
          </h3>
          <el-input
            v-model="generatedLongLinks"
            type="textarea"
            autosize
            readonly
          />
        </div>

        <div
          v-if="generatedBitlyLinks"
          class="links-result-container"
        >
          <h3>
            Generated Bitly Links
          </h3>
          <el-input
            v-model="generatedBitlyLinks"
            type="textarea"
            autosize
            readonly
          />
          <div class="button-group">  
            <el-button
              v-clipboard:copy="generatedBitlyLinks"
              v-clipboard:success="copySuccessed"
              type="primary"
            >
              {{ copyText }}
            </el-button>
          </div>
        </div>
      </div>
    </el-form>
  </section>
</template>

<script>
import clipboard from '../../directive/clipboard'
import { createBitlyLinks } from '../../api/paylinks'
import { GOXIP_PAYLINK_DOMAIN } from '../../utils/const'

export default {
  name: 'OtherPaylinksGenerator',
  directives: {
    clipboard,
  },
  data() {
    const validateUrl = (options, value, callback) => {
      if (options.required && !value) {
        return callback(new Error(this.$t('error.thisFieldIsRequired')))
      }

      return callback()
    }

    return {
      paylinksForm: {
        utmSource: 'fb',
        utmMedium: '',
        utmCampaign: '',
        utmSalescode: '',
        pageTitle: '',
        bannerImage: '',
        shopNowLink: '',
        productLink1: '',
        productLink2: '',
        productLink3: '',
        productLink4: '',
        productLink5: '',
        shopNowLongLink: '',
        productLongLink1: '',
        productLongLink2: '',
        productLongLink3: '',
        productLongLink4: '',
        productLongLink5: '',
        shopNowBitlyLink: '',
        productBitlyLink1: '',
        productBitlyLink2: '',
        productBitlyLink3: '',
        productBitlyLink4: '',
        productBitlyLink5: '',
      },
      paylinksFormRules: {
        marketingU1: [{ required: true, message: this.$t('error.thisFieldIsRequired'), trigger: 'change' }],
        shopNowLink: [{ required: true, validator: validateUrl, trigger: 'blur' }],
        productLink1: [{ required: true, validator: validateUrl, trigger: 'blur' }],
        productLink2: [{ required: false, validator: validateUrl, trigger: 'blur' }],
        productLink3: [{ required: false, validator: validateUrl, trigger: 'blur' }],
        productLink4: [{ required: false, validator: validateUrl, trigger: 'blur' }],
        productLink5: [{ required: false, validator: validateUrl, trigger: 'blur' }],
      },
      type: null,
      typeOptions: [{
        'name': 'Marketplace',
        'value': 'marketplace'
      }],
      generatedLongLinks: null,
      generatedBitlyLinks: null,
      copyText: 'Copy',
    }
  },
  methods: {
    async generateBitlyLinks(longLinks) {
      const response = await createBitlyLinks(longLinks)

      const labels = [
        'Shop Now Link:',
        'Product Link #1:',
        'Product Link #2:',
        'Product Link #3:',
        'Product Link #4:',
        'Product Link #5:',
      ]

      const rows = []

      for (let i = 0; i < labels.length; i++) {
        rows.push(labels[i] + '\n')

        if (i < response.data.length - 1) {
          const bitlyUrl = response.data[i].bitly_url

          if (bitlyUrl === null || bitlyUrl === '') {
            rows.push('N/A\n\n')
          } else {
            rows.push(bitlyUrl + '\n\n')
          }
        } else {
          rows.push('-\n\n')
        }
      }

      rows.push('*** BACK UP *** Shop Now Link:\n')

      const bitlyUrl = response.data[response.data.length - 1].bitly_url

      if (bitlyUrl === null || bitlyUrl === '') {
        rows.push('N/A\n\n')
      } else {
        rows.push(bitlyUrl + '\n\n')
      }

      this.generatedBitlyLinks = rows.join('')
    },
    generatePaylink(destinationUrl, basicQueries, pageTitle, bannerImage, isSuperMode) {
      let paylink = ''

      if (destinationUrl.indexOf('?') > 0) {
        paylink = `${destinationUrl}&${basicQueries.join('&')}`
      } else {
        paylink = `${destinationUrl}?${basicQueries.join('&')}`
      }
      
      let extraQueries = []

      if (pageTitle && pageTitle.length > 0) {
        extraQueries.push(`title=${encodeURIComponent(pageTitle)}`)
      }

      if (bannerImage && bannerImage.length > 0) {
        extraQueries.push(`banner_image=${bannerImage}`)
      }

      if (extraQueries.length > 0) {
        if (isSuperMode) {
          paylink = `${GOXIP_PAYLINK_DOMAIN}/hk/affiliate?url=${encodeURIComponent(paylink)}&${extraQueries.join('&')}`
        } else {
          paylink = `${paylink}&${extraQueries.join('&')}`
        }
      }

      return paylink
    },
    handleClear() {
      this.$refs.paylinksForm.resetFields()
      this.generatedLongLinks = null
      this.generatedBitlyLinks = null
    },
    handleGenerate() {
      this.$refs.paylinksForm.validate((valid) => {
        if (valid) {
          let longLinks = []
          this.generatedLongLinks = null
          this.generatedBitlyLinks = null

          let basicQueries = []
      
          if (this.paylinksForm.utmSource.length > 0) {
            basicQueries.push(`utm_source=${this.paylinksForm.utmSource}`)
          }

          if (this.paylinksForm.utmMedium.length > 0) {
            basicQueries.push(`utm_medium=${this.paylinksForm.utmMedium}`)
          }
          
          if (this.paylinksForm.utmCampaign.length > 0) {
            basicQueries.push(`utm_campaign=${this.paylinksForm.utmCampaign}`)
          }
          
          if (this.paylinksForm.utmSalescode.length > 0) {
            basicQueries.push(`utm_salescode=${this.paylinksForm.utmSalescode}`)
          }

          longLinks.push(this.generatePaylink(this.paylinksForm.shopNowLink, basicQueries, this.paylinksForm.pageTitle, this.paylinksForm.bannerImage, false))

          if (this.paylinksForm.productLink1.length > 0) {
            longLinks.push(this.generatePaylink(this.paylinksForm.productLink1, basicQueries))
          }

          if (this.paylinksForm.productLink2.length > 0) {
            longLinks.push(this.generatePaylink(this.paylinksForm.productLink2, basicQueries))
          }

          if (this.paylinksForm.productLink3.length > 0) {
            longLinks.push(this.generatePaylink(this.paylinksForm.productLink3, basicQueries))
          }

          if (this.paylinksForm.productLink4.length > 0) {
            longLinks.push(this.generatePaylink(this.paylinksForm.productLink4, basicQueries))
          }
          
          if (this.paylinksForm.productLink5.length > 0) {
            longLinks.push(this.generatePaylink(this.paylinksForm.productLink5, basicQueries))
          }

          longLinks.push(this.generatePaylink(this.paylinksForm.shopNowLink, basicQueries, this.paylinksForm.pageTitle, this.paylinksForm.bannerImage, true))

          this.generatedLongLinks = longLinks.join('\n\n')
          this.generateBitlyLinks(longLinks)
        } else {
          return false
        }

        return undefined
      })
    },
    copySuccessed() {
      this.copyText = 'Copied'
      setTimeout(() => {
        this.copyText = 'Copy'
      }, 3000)
    },
  }
}
</script>

<style lang="scss" scoped>

section {
  width: 100%;
  max-width: 650px;
  border: $border-base;
  border-radius: $border-radius-base;
  margin: 20px auto;
  padding: 10px;

  button {
    margin: 5px auto;
    width: 40%;
  }

  .el-form {
    .el-select {
      width: 100%;
    }
  }

  .links-result-container {
    display: flex;
    flex-flow: column;
    border-top: $border-base;
    margin-top: 10px;
    h3 {
      text-align: center;
    }
    button {
      margin-top: 15px;
    }
  }

  .button-group {
    display: flex;
  }
}

</style>